/**
 * Environment detection utilities
 */

/**
 * Check if code is running on the server (Node.js) vs client (browser)
 * @returns true if running server-side, false if running client-side
 */
export function isServerSide(): boolean {
  return typeof window === 'undefined';
}

/**
 * Check if sessionStorage is available and functional
 * @returns true if sessionStorage can be used, false otherwise
 */
export function isSessionStorageAvailable(): boolean {
  if (typeof Storage === 'undefined') return false;

  try {
    const key = '__test_storage__';
    sessionStorage.setItem(key, 'test');
    sessionStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}
